/* eslint-disable jsx-a11y/control-has-associated-label */
import { FormattedMessage } from 'react-intl';
import React from 'react';

export default () => (
    <header className="notifications-header">
        <ul className="tab-navigation">
            <li>
                <a href className="tab-name active-tab"><FormattedMessage id="NOTIFICATIONS" /></a>
            </li>
        </ul>
    </header>
);
